"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Dropdown = require("./Dropdown.Styled");

var _utility = require("../utility");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Button = _ref => {
  let {
    label,
    onChange: _onChange,
    value,
    items,
    emptySelectionLabel = '-select-',
    className
  } = _ref;
  if (typeof _onChange !== 'function' || !Array.isArray(items) || !emptySelectionLabel) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement(_Dropdown.StyledDropdown, {
    className: className
  }, label && /*#__PURE__*/_react.default.createElement(_Dropdown.Label, null, label), /*#__PURE__*/_react.default.createElement(_Dropdown.Select, {
    value: value,
    onChange: e => _onChange(e.target.value)
  }, /*#__PURE__*/_react.default.createElement(_Dropdown.Option, {
    key: (0, _utility.getUUID)(),
    value: ''
  }, emptySelectionLabel), items.map(item => /*#__PURE__*/_react.default.createElement(_Dropdown.Option, {
    key: (0, _utility.getUUID)(),
    value: item.key
  }, item.value))));
};

var _default = Button;
exports.default = _default;